const Intro1 = () => {
  return (
    <div className="intro-content">
      <h1 className="intro-content__title">مدیریت هوشمند  بحران های سلامت</h1>

      <p className="u-margin-bottom-small-2">ذیل این مجموعه سامانه ها خدمات مختلفی در حوزه های حمل و نقل عمومی ، اصناف ، مسافران (میزبانی) در اختیار شهروندان قرار گرفته است.</p>
      <p>هدف این سامانه ها افزایش توان شهروندان در مشارکتی شهروندان در کنترل بیماری های فراگیر بوده است.</p>
    </div>
  );
}

export default Intro1;